import { Component } from '@angular/core';

@Component({
    selector: 'kui-header-brand',
    templateUrl: './header-brand.component.html',
    standalone: false
})
export class KuiHeaderBrandComponent { }
